import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../campaigns/assets/images/default-big.png'
import _imports_1 from '@/assets/images/android.svg'
import _imports_2 from '@/assets/images/ios.svg'
import _imports_3 from '../campaigns/assets/images/edit.svg'
import _imports_4 from '@/assets/images/copy-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-3705e2f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-col-12 p-grid" }
const _hoisted_2 = {
  key: 0,
  class: "p-col-4"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  class: "main-image"
}
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex p-flex-column p-col-12 p-flex-wrap"
}
const _hoisted_6 = { class: "company-name" }
const _hoisted_7 = { class: "p-col-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign category", -1))
const _hoisted_9 = { class: "campaign-type" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "p-col-2"
}
const _hoisted_13 = { class: "budget" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "img"
}, null, -1))
const _hoisted_15 = { class: "budget" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "img"
}, null, -1))
const _hoisted_17 = {
  key: 2,
  class: "p-col-2"
}
const _hoisted_18 = { class: "p-d-flex p-ai-start" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign CPM", -1))
const _hoisted_20 = { class: "budget" }
const _hoisted_21 = {
  key: 3,
  class: "p-col-2"
}
const _hoisted_22 = { class: "p-d-flex p-ai-start" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign CPC", -1))
const _hoisted_24 = {
  key: 0,
  class: "budget"
}
const _hoisted_25 = {
  key: 1,
  class: "budget"
}
const _hoisted_26 = {
  key: 4,
  class: "vertical-line"
}
const _hoisted_27 = {
  key: 5,
  class: "p-col-2"
}
const _hoisted_28 = { class: "p-d-flex p-ai-start" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "CAMPAIGN MAX PAYOUT", -1))
const _hoisted_30 = { class: "budget" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" }, null, -1))
const _hoisted_32 = { class: "p-col-3" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "p-mt-4 p-d-flex p-flex-column p-ai-center small-gap"
}
const _hoisted_35 = { class: "p-d-flex small-gap" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-mr-3 p-ml-3" }, "or", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" }, null, -1))
const _hoisted_38 = {
  key: 6,
  class: "p-col-3"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Region", -1))
const _hoisted_40 = { class: "p-d-flex p-ai-start p-mt-3" }
const _hoisted_41 = { class: "region w-100" }
const _hoisted_42 = {
  key: 7,
  class: "p-col-3"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Region", -1))
const _hoisted_44 = { class: "p-d-flex p-ai-start p-mt-3" }
const _hoisted_45 = { class: "region w-100" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-4" }, null, -1))
const _hoisted_47 = {
  key: 1,
  class: "p-col-8 p-text-bold p-mt-4"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign Details", -1))
const _hoisted_50 = { class: "p-col-12 p-d-flex p-grid product-details" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "p-d-flex p-flex-wrap p-justify-between" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "link-campaignInfos p-pr-6" }
const _hoisted_55 = ["src"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "p-ml-3 copy-img"
}, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1))
const _hoisted_59 = { class: "p-col-12 p-d-flex p-grid" }
const _hoisted_60 = { class: "p-mb-4" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-check",
  style: {"color":"#4EC461","margin-right":"7px"}
}, null, -1))
const _hoisted_62 = { class: "p-text-bold" }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "p-d-flex" }
const _hoisted_65 = { class: "calll-actions" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1))
const _hoisted_68 = { class: "p-col-12" }
const _hoisted_69 = {
  key: 0,
  style: {"background":"rgba(0, 0, 0, 0.05)","width":"100%","margin-top":"40px","margin-bottom":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_chip = _resolveComponent("status-chip")!
  const _component_ask_hint = _resolveComponent("ask-hint")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_input_talking_point = _resolveComponent("input-talking-point")!
  const _component_uploaded_file_views = _resolveComponent("uploaded-file-views")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["p-grid background", [_ctx.shortPreview ? 'p-col-12' : 'p-col-10']]),
    style: _normalizeStyle(`--my-src: url(${_ctx.campaignInfo?.photo})`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.shortPreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.campaignInfo?.photo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.campaignInfo?.photo,
                  class: "main-image"
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("img", _hoisted_4))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["p-d-flex p-grid p-justify-between", [_ctx.shortPreview ? 'p-col-12' : 'p-col-8']])
      }, [
        (!_ctx.shortPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.campaignInfo)
                ? (_openBlock(), _createBlock(_component_status_chip, {
                    key: 0,
                    status: _ctx.campaignInfo?.status
                  }, null, 8, ["status"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.campaignInfo?.name), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("img", {
              src: _ctx.campaignTypeIcons[_ctx.campaignInfo?.targetMarket?.type || _ctx.campaignInfo?.targetMarkets?.type]
            }, null, 8, _hoisted_10),
            _createTextVNode(" " + _toDisplayString(_ctx.campaignInfo?.targetMarket?.title || _ctx.campaignInfo?.targetMarkets?.title), 1)
          ])
        ]),
        _hoisted_11,
        (_ctx.campaignInfo?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("h6", null, [
                _createTextVNode("Campaign CPI "),
                _createVNode(_component_ask_hint, { "tooltip-text": 'CPI (Cost Per Install) is the price you will be paid for each install that you generate' +
              ' through the tracking link that you receive for the campaign.' }, null, 8, ["tooltip-text"])
              ]),
              _createElementVNode("span", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.calculateCpiRate(_ctx.campaignInfo?.cpi?.android?.amount, _ctx.campaignInfo?.appliedFee)) + " " + _toDisplayString(_ctx.campaignInfo?.budget?.currency), 1)
              ]),
              _createElementVNode("span", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.calculateCpiRate(_ctx.campaignInfo?.cpi?.ios?.amount, _ctx.campaignInfo?.appliedFee)) + " " + _toDisplayString(_ctx.campaignInfo?.budget?.currency), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.campaignInfo?.paymentMethod === _ctx.CampaignPaymentMethod.CPM)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_ask_hint, { "tooltip-text": 'CPM (Cost Per Mille) is the price you will be paid for every 1000 views that you' +
              ' generate on the video that you create for this campaign.' }, null, 8, ["tooltip-text"])
              ]),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.calculateCpiRate(_ctx.campaignInfo?.cpm?.amount, _ctx.campaignInfo?.appliedFee)) + " " + _toDisplayString(_ctx.campaignInfo?.budget?.currency), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.campaignInfo?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_ask_hint, { "tooltip-text": 'CPC (Cost Per Click) is the price you will be paid for each real click that you' +
              ' generate on the tracking link that you will receive for this campaign.' }, null, 8, ["tooltip-text"])
              ]),
              (_ctx.user?.type !== 'brandOwner')
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.calculateCpiRate(_ctx.campaignInfo?.cpc?.amount, _ctx.campaignInfo?.appliedFee)) + " " + _toDisplayString(_ctx.campaignInfo?.cpc?.currency), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.calculateCpiRate(_ctx.campaignInfo?.cpc?.amount, _ctx.campaignInfo?.appliedFee)) + " " + _toDisplayString(_ctx.campaignInfo?.budget?.currency), 1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.campaignInfo?.paymentMethod === _ctx.CampaignPaymentMethod.CPM)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26))
          : _createCommentVNode("", true),
        (_ctx.campaignInfo?.paymentMethod === _ctx.CampaignPaymentMethod.CPM)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_ask_hint, { "tooltip-text": 'This is the max payout that a single creator can gain from this campaign.' +
              ' E.g. if the max payout cap is $3000 and the CPM rate is $20 then after the you have gained 150,000' +
              ' views you will no longer earn from further views generated within the 30 days as you will have hit' +
              ' the $3000 cap.' }, null, 8, ["tooltip-text"])
              ]),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.getPayoutCap(_ctx.applications, _ctx.campaignInfo?.cpm?.payoutCap, _ctx.campaignInfo?.budget?.currency, _ctx.campaignInfo?.appliedFee)), 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("h6", null, [
            _createTextVNode(" APPLICATION TIME LEFT "),
            _withDirectives(_createElementVNode("img", {
              class: "p-ml-2 pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editOptions.dates = !_ctx.editOptions.dates)),
              src: _imports_3
            }, null, 512), [
              [_vShow, _ctx.campaignInfo?.creator?.id === _ctx.user?.id || _ctx.user?.type === 'admin']
            ])
          ]),
          (!_ctx.editOptions.dates)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_33, _toDisplayString(_ctx.parseCampaignEndTimeLeft(_ctx.campaignInfo?.dates?.endDate) || 'Until Budget is Complete'), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_Calendar, {
                    id: "minmax",
                    modelValue: _ctx.endDateCampaign,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDateCampaign) = $event)),
                    minDate: _ctx.enD,
                    manualInput: false
                  }, null, 8, ["modelValue", "minDate"]),
                  (_ctx.editOptions.dates)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-success",
                        icon: "pi pi-check",
                        "aria-label": "Submit",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.updateCampaignData({ dates: { startDate: _ctx.startDate, endDate: _ctx.endDateCampaign } });
              _ctx.editOptions.dates = !_ctx.editOptions.dates})
                      }))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_36,
                _createVNode(_component_Button, {
                  label: "Set Infinite",
                  severity: "secondary",
                  icon: "pi pi-check",
                  class: "p-button-sm",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.updateCampaignData({ dates: { startDate: _ctx.startDate, endDate: undefined } });
            _ctx.editOptions.dates = !_ctx.editOptions.dates})
                })
              ]))
        ]),
        _hoisted_37,
        (_ctx.shortPreview && _ctx.campaignInfo?.desiredRegions?.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.campaignInfo?.desiredRegions?.value), 1),
                _withDirectives(_createVNode(_component_ask_hint, null, null, 512), [
                  [
                    _directive_tooltip,
                    _ctx.campaignInfo?.desiredRegions.name,
                    void 0,
                    { right: true }
                  ]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.shortPreview && _ctx.campaignInfo?.desiredRegions[0]?.name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.campaignInfo?.desiredRegions[0]?.value), 1),
                _withDirectives(_createVNode(_component_ask_hint, null, null, 512), [
                  [
                    _directive_tooltip,
                    _ctx.campaignInfo?.desiredRegions[0].name,
                    void 0,
                    { right: true }
                  ]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _hoisted_46,
      (_ctx.campaignInfo?.paymentMethod === _ctx.CampaignPaymentMethod.CPM)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, " ALL CPM CAMPAIGNS HAVE A 30 DAY TRACKING PERIOD. ONCE YOUR VIDEO IS LIVE ON YOUTUBE AND IS SUBMITTED HERE THE 30 DAYS OF TRACKING BEGINS. ALL VIEWS GENERATED WITHIN THIS 30 DAY PERIOD WILL BE PAID IN ACCORDANCE WITH THE CAMPAIGN CPM, MAX PAYOUT AND T&C REGARDING THE BUDGET RUNNING OUT. MAKE SURE TO UPLOAD YOUR VIDEO HERE WITHIN 24 HOURS OF IT GOING LIVE ON YOUTUBE. YOU ARE NOT GUARANTEED PARTICIPATION OR COMPENSATION IN THIS CAMPAIGN UNTIL YOUR DRAFT IS ACCEPTED. "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.displayModeratedContent(_ctx.hideInfo!.isCampaignCPM, _ctx.hideInfo?.applicationStatus as CampaignApplicationStatusValues))
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.shortPreview ? 'p-col-6' : 'p-col-4'])
            }, [
              _createElementVNode("h6", null, [
                _createTextVNode(" Campaign Description "),
                _withDirectives(_createElementVNode("img", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editOptions.productName = !_ctx.editOptions.productName)),
                  class: "p-ml-2 pointer",
                  src: _imports_3
                }, null, 512), [
                  [_vShow, _ctx.campaignInfo?.creator?.id === _ctx.user?.id || _ctx.user?.type === 'admin']
                ])
              ]),
              _createElementVNode("h5", null, [
                (!_ctx.editOptions.productName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.campaignInfo?.productName), 1))
                  : _createCommentVNode("", true),
                (_ctx.editOptions.productName)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 1,
                      class: "default-input w-75",
                      type: "text",
                      modelValue: _ctx.productName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productName) = $event)),
                      placeholder: "Tell Creators about your campaign"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.editOptions.productName)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      class: "p-button-success",
                      icon: "pi pi-check",
                      "aria-label": "Submit",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.updateCampaignData({ productName: _ctx.productName }, 'productName'); _ctx.editOptions.productName = !_ctx.editOptions.productName})
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            (_ctx.campaignInfo?.productUrls?.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([_ctx.shortPreview ? 'p-col-6' : 'p-col-8'])
                }, [
                  _createElementVNode("div", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignInfo?.productUrls, (linkObj, idx) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `${idx}_liObj`
                      }, [
                        (linkObj.value && linkObj.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _createElementVNode("h6", null, _toDisplayString(_ctx.parseTitle[linkObj?.type]) + "LINK", 1),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("img", {
                                  src: _ctx.linksIcons[linkObj?.type]
                                }, null, 8, _hoisted_55),
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (_ctx.openLink(linkObj.value)),
                                  class: "links"
                                }, _toDisplayString(linkObj?.value), 9, _hoisted_56),
                                _hoisted_57
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", {
              class: _normalizeClass([[_ctx.shortPreview ? 'p-col-12' : 'p-col-6'], "talking-point"])
            }, [
              _createElementVNode("h6", null, [
                _createTextVNode(" Requirements and talking points "),
                _withDirectives(_createElementVNode("img", {
                  class: "p-ml-2 pointer",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editOptions.talkingPoints = !_ctx.editOptions.talkingPoints)),
                  src: _imports_3
                }, null, 512), [
                  [_vShow, _ctx.campaignInfo?.creator?.id === _ctx.user?.id || _ctx.user?.type === 'admin']
                ])
              ]),
              (!_ctx.editOptions.talkingPoints)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.campaignInfo?.talkingPoints, (campaignInfo, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${index}_talk`,
                      class: "p-d-flex"
                    }, [
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createElementVNode("span", _hoisted_62, _toDisplayString(campaignInfo), 1)
                      ])
                    ]))
                  }), 128))
                : _createCommentVNode("", true),
              (_ctx.editOptions.talkingPoints)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talkingPoints, (point, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: point,
                        class: "p-mb-3"
                      }, [
                        _createElementVNode("h6", null, "Talking Point " + _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_Button, {
                            class: "p-button-secondary p-mr-2",
                            icon: "pi pi-times",
                            onClick: ($event: any) => (_ctx.talkingPoints.splice(index, 1))
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_input_talking_point, {
                            onChangeTalking: _ctx.changedTalkingInput,
                            "index-input": +index,
                            "value-input": point
                          }, null, 8, ["onChangeTalking", "index-input", "value-input"])
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("span", {
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addTalkingPoint && _ctx.addTalkingPoint(...args))),
                      class: "add-point"
                    }, "+ Add Another Talking Point"),
                    (_ctx.editOptions.talkingPoints)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "p-button-success",
                          icon: "pi pi-check",
                          label: "Save",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.updateCampaignData({ talkingPoints: _ctx.talkingPoints }); _ctx.editOptions.talkingPoints = !_ctx.editOptions.talkingPoints})
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.shortPreview ? 'p-col-12' : 'p-col-6'])
            }, [
              _createElementVNode("h6", null, [
                _createTextVNode(" Call to Action "),
                _withDirectives(_createElementVNode("img", {
                  class: "p-ml-2 pointer",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editOptions.callToAction = !_ctx.editOptions.callToAction)),
                  src: _imports_3
                }, null, 512), [
                  [_vShow, _ctx.campaignInfo?.creator?.id === _ctx.user?.id || _ctx.user?.type === 'admin']
                ])
              ]),
              _createElementVNode("h6", _hoisted_65, [
                (!_ctx.editOptions.callToAction)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(`“${_ctx.campaignInfo?.callToAction}”`), 1))
                  : _createCommentVNode("", true),
                (_ctx.editOptions.callToAction)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 1,
                      class: "default-input w-75",
                      type: "text",
                      modelValue: _ctx.callToAction,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.callToAction) = $event)),
                      placeholder: "Tell Creators about your campaign"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.editOptions.callToAction)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      class: "p-button-success",
                      icon: "pi pi-check",
                      "aria-label": "Submit",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.updateCampaignData({ callToAction: _ctx.callToAction }); _ctx.editOptions.callToAction = !_ctx.editOptions.callToAction})
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ]),
          _hoisted_67,
          _createElementVNode("h6", null, [
            _createTextVNode("Attachments "),
            _withDirectives(_createElementVNode("img", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openBasic = !_ctx.openBasic)),
              class: "p-ml-2 pointer",
              src: _imports_3
            }, null, 512), [
              [_vShow, _ctx.campaignInfo?.creator?.id === _ctx.user?.id || _ctx.user?.type === 'admin']
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_uploaded_file_views, {
              onUpdateAtt: _ctx.updateAtt,
              "is-owner": _ctx.campaignInfo?.creator?.id === _ctx.user?.id,
              "open-basic": _ctx.openBasic,
              "campaign-id": _ctx.campaignInfo?.id,
              campaignInfos: _ctx.campaignInfo?.attachments
            }, null, 8, ["onUpdateAtt", "is-owner", "open-basic", "campaign-id", "campaignInfos"])
          ]),
          (!_ctx.shortPreview)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_69))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 6))
}